import { USER_ROLES } from '../../constants/roles';

export const CARE_RECORD_VISIBILITY = {
  SHARED: 'care_team',
  PRIVATE: 'private',
};

export const isCareRecordPrivate = (record = {}) => {
  const visibility = String(record?.visibility || '').trim().toLowerCase();
  return visibility === CARE_RECORD_VISIBILITY.PRIVATE;
};

export const canManageCareRecordPrivacy = (viewerRole) => (
  viewerRole === USER_ROLES.CARE_OWNER
  || viewerRole === USER_ROLES.CARE_PARTNER
);

export const canViewerSeeCareRecord = ({
  viewerRole,
  record = {},
} = {}) => {
  if (isCareRecordPrivate(record)) {
    return canManageCareRecordPrivacy(viewerRole);
  }

  return [
    USER_ROLES.CARE_OWNER,
    USER_ROLES.CARE_PARTNER,
    USER_ROLES.CAREGIVER,
    USER_ROLES.THERAPIST,
  ].includes(viewerRole);
};

export const filterCareRecordsForViewer = (records = [], viewerRole) => {
  if (!viewerRole) {
    return records;
  }

  return records.filter((record) => canViewerSeeCareRecord({
    viewerRole,
    record,
  }));
};

export const getToggledCareRecordVisibility = (record = {}) => (
  isCareRecordPrivate(record)
    ? CARE_RECORD_VISIBILITY.SHARED
    : CARE_RECORD_VISIBILITY.PRIVATE
);
